import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _BlendTypes;

import { BlendType, gl } from '@antv/l7-core';
export var BlendTypes = (_BlendTypes = {}, _defineProperty(_BlendTypes, BlendType.additive, {
  enable: true,
  func: {
    srcRGB: gl.ONE,
    dstRGB: gl.ONE,
    srcAlpha: 1,
    dstAlpha: 1
  }
}), _defineProperty(_BlendTypes, BlendType.none, {
  enable: false
}), _defineProperty(_BlendTypes, BlendType.normal, {
  enable: true,
  func: {
    srcRGB: gl.SRC_ALPHA,
    dstRGB: gl.ONE_MINUS_SRC_ALPHA,
    srcAlpha: 1,
    dstAlpha: 1
  }
}), _defineProperty(_BlendTypes, BlendType.subtractive, {
  enable: true,
  func: {
    srcRGB: gl.ONE,
    dstRGB: gl.ONE,
    srcAlpha: gl.ZERO,
    dstAlpha: gl.ONE_MINUS_SRC_COLOR
  },
  equation: {
    rgb: gl.FUNC_SUBTRACT,
    alpha: gl.FUNC_SUBTRACT
  }
}), _defineProperty(_BlendTypes, BlendType.max, {
  enable: true,
  func: {
    srcRGB: gl.ONE,
    dstRGB: gl.ONE
  },
  equation: {
    rgb: gl.MAX_EXT
  }
}), _defineProperty(_BlendTypes, BlendType.min, {
  enable: true,
  func: {
    srcRGB: gl.ONE,
    dstRGB: gl.ONE
  },
  equation: {
    rgb: gl.MIN_EXT
  }
}), _BlendTypes);